import React, { Component } from "react";

export class DetailBasic extends Component {
    render() {
        return <div id="wrappDetailBasic" className="detail-process">

            <div className="wrapp-interna-process-banner">
                <img src={require('../../images/basico.jpg')} />
            </div>

            <h2 class="text-center d-inline-block margin-top-40">Entrenamiento b&aacute;sico</h2>
            <div className="text-center d-inline-block">
                <span>30 horas</span><span>|</span><span>$695.000</span>
            </div>
            <p>
                El propósito del Taller Básico es descubrir todo aquello que no funciona en la vida de un ser humano, mejor conocido como barreras limitantes o paradigmas que en cierta forma, afectan los resultados que producen insatisfacción personal.
            </p>

            <p>
                Son tres días de descubrimiento continuo, donde serás tú el protagonista de tu propia historia, tomando tus propias decisiones y redescubriendo tus sueños.
            </p>

            <p>
                El Taller Básico está diseñado para realzar en el individuo su eficacia y eficiencia. El Taller está enfocado para abordar los problemas clave de vida adulta y diseñar un camino de solución incluyendo la profesión, la familia y relaciones, la responsabilidad personal, el cumplimiento, la comunicación, y la autoexpresión. El Básico de LIFE también esta enfocado para trabajar todas las dimensiones de naturaleza humana: intelecto y emoción, cuerpo y espíritu.
            </p>

            <p>
                Impactará directamente las siguientes áreas de tu vida:
            </p>

            <ul>
                <li>
                    Distinguir claramente entre excusas y resultados
                </li>
                <li>
                    Desarrollar tu inteligencia emocional
                </li>
                <li>
                    Un profundo nivel de libertad y consciencia
                </li>
                <li>
                    Resultados en tus relaciones personales y profesionales
                </li>
                <li>
                    Soltar paradigmas, actitudes y comportamientos limitantes
                </li>
                <li>
                    El valor de honrarte con tu palabra
                </li>
                <li>
                    Reclamar un nuevo sentido de vida
                </li>
                <li>
                    Comenzar a vivir desde el paradigma Ganar- Ganar
                </li>
            </ul>
        </div>
    }
}